<template>
<v-select box :multiple="multiple" v-model="selectedScenes" :rules="rules" :items="allScenes" :label="label" :no-data-text="$t('scene.no_scene_available')" :clearable="clearable">
  <template slot="item" slot-scope="data">
    <v-list-tile-avatar>
      <img :src="$FuncTypeIcons['56373']"></img>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title v-text="data.item.text"></v-list-tile-title>
      <v-list-tile-sub-title class="caption" v-text="data.item.hostname"></v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action style="min-width:12px">
      <v-checkbox color="primary" v-model="data.tile.props.value"></v-checkbox>
    </v-list-tile-action>
  </template>
</v-select>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'SceneSelector',
  mixins: [UserAuth],
  props: {
    value: {
      type: [String, Object, Array]
    },
    label: {
      type: String
    },
    clearable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array
    }
  },
  watch: {
    value(val) {
      let allSceneValue = this.allScenes.map(s => s.value);
      if (typeof val === 'string' || val instanceof String) {
        let existed = allSceneValue.includes(val);
        if (!existed) {
          this.selectedScenes = null;
        }
      }
      if (val instanceof Array) {
        let filtered = val.filter(s => {
          return allSceneValue.includes(s)
        })
        if (val.length != filtered.length) {
          this.selectedScenes = filtered;
        }
      }
    }
  },
  computed: {
    selectedScenes: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    allScenes() {
      let list = [];
      Object.keys(this.userScene || {}).forEach(mac => {
        Object.values(this.userScene[mac]).forEach(s => {
          list.push({
            value: `${mac}-${Buffer.from(s.title).toString('base64')}`,
            text: s.title,
            hostname: (this.userMacInfo[mac] || {}).hostname || mac
          });
        });
      });
      return list;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/scene/SceneSelector.vue